import { cn } from '@virginexperiencedays/tailwind';

import type { HTMLAttributes } from 'react';
import { LinkWrap, type LinkWrapProps } from '../LinkWrap';

// list of pills
export const PillList = ({ className, children, ...rest }: HTMLAttributes<HTMLUListElement>) => (
  <ul className={cn('flex flex-wrap gap-2', className)} {...rest}>
    {children}
  </ul>
);

export const PillListItem = ({ className, children, ...rest }: HTMLAttributes<HTMLLIElement>) => (
  <li className={cn('flex', className)} {...rest}>
    {children}
  </li>
);

export const Pill = ({ children, className, ...rest }: LinkWrapProps) => (
  <LinkWrap
    className={cn(
      'border-border-neutral-strong bg-background-page rounded-lg border border-solid p-2 text-sm font-semibold',
      'hover:border-primary-200 hover:bg-primary-100 hover:text-brand',
      'dark:hover:bg-background-primary-faded-hover dark:hover:border-border-primary-faded dark:hover:text-neutral',
      className
    )}
    {...rest}
  >
    {children}
  </LinkWrap>
);
